export const STYLE_MAP = {
  default: {
    'border-color': '#00A4F2',
    'background-color': '#00A4F2'
  },
  purple: {
    'border-color': '#946CF2',
    'background-color': '#946CF2'
  },
  slate: {
    'border-color': '#6575ff',
    'background-color': '#6575ff'
  },
  aqua: {
    'border-color': '#29c3ff',
    'background-color': '#29c3ff'
  },
  turquoise: {
    'border-color': '#00BDB2',
    'background-color': '#00BDB2'
  },
  'orange-red': {
    'border-color': '#F56428',
    'background-color': '#F56428'
  },
  red: {
    'border-color': '#e61e1e',
    'background-color': '#e61e1e'
  },
  brown: {
    'border-color': '#86696b',
    'background-color': '#86696b'
  },
  tomato: {
    'border-color': '#fe674a',
    'background-color': '#fe674a'
  },
  orange: {
    'border-color': '#FFAA10',
    'background-color': '#FFAA10'
  },
  yellow: {
    'border-color': '#ffaa10',
    'background-color': '#ffaa10'
  },
  gray: {
    'border-color': '#7c879b',
    'background-color': '#7c879b'
  },
  white: {
    'border-color': '#ffffff',
    'background-color': '#ffffff'
  },
  deepSteelblue: {
    'border-color': '#1f94d2',
    'background-color': '#1f94d2'
  },
  colmo: {
    'border-color': '#b35336',
    'background-color': '#b35336'
  }
}

export const STYLE_MAP_DIABLO = {
  default: {
    'border-color': '#0490d3',
    'background-color': '#0490d3'
  },
  purple: {
    'border-color': '#805ed1',
    'background-color': '#805ed1'
  },
  slate: {
    'border-color': '#5865DC',
    'background-color': '#5865DC'
  },
  aqua: {
    'border-color': '#25A8DC',
    'background-color': '#25A8DC'
  },
  turquoise: {
    'border-color': '#039D95',
    'background-color': '#039D95'
  },
  'orange-red': {
    'border-color': '#F56428',
    'background-color': '#F56428'
  },
  red: {
    'border-color': '#c61a1c',
    'background-color': '#c61a1c'
  },
  brown: {
    'border-color': '#745b5e',
    'background-color': '#745b5e'
  },
  tomato: {
    'border-color': '#d35926',
    'background-color': '#d35926'
  },
  orange: {
    'border-color': '#E09916',
    'background-color': '#E09916'
  },
  yellow: {
    'border-color': '#BE8214',
    'background-color': '#BE8214'
  },
  gray: {
    'border-color': '#6b7587',
    'background-color': '#6b7587'
  },
  white: {
    'border-color': '#ffffff',
    'background-color': '#ffffff'
  },
  deepSteelblue: {
    'border-color': '#1f94d2',
    'background-color': '#1f94d2'
  },
  colmo: {
    'border-color': '#b35336',
    'background-color': '#b35336'
  }
}



// WEBPACK FOOTER //
// ./packages/dof-switch/style.js